// extracted by mini-css-extract-plugin
export var Input = "default-module--Input--2QPWX";
export var Text_Input = "default-module--Text_Input--125N8";
export var Numeric_Input = "default-module--Numeric_Input--1Huxr";
export var Password_Input = "default-module--Password_Input--2npwx";
export var Email_Input = "default-module--Email_Input--3OvCN";
export var Select = "default-module--Select--18Xgh";
export var Choice_Label = "default-module--Choice_Label--p6lPc";
export var Choice_Label_Checked = "default-module--Choice_Label_Checked--fm95k";
export var Choice_Input = "default-module--Choice_Input--ueM0B";